// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"1d383e2b","518":"3825318d"}[chunkId] + ".chunk.js";
};